<template>
    <Container>
        <div
            class="ft-mask"
            @click.self="maskClick && maskClick()"
            @touchmove.prevent.stop="() => {}"
            v-if="preventStopMove"
        >
            <slot />
        </div>
        <div class="ft-mask" @click.self="maskClick && maskClick()" v-else>
            <slot />
        </div>
    </Container>
</template>

<script>
import Container from '../Container/index.vue';
export default {
    props: ['maskClick', 'preventStopMove'],
    components: {
        Container
    }
};
</script>

<style lang="less">
.ft-mask {
    position: fixed;
    z-index: 2001;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
}
</style>
